import {
  Checkbox,
  Divider,
  HStack,
  IconStarReview,
  Progress,
  StackProps,
  Text,
  VStack,
} from '@gazin/ecommerce-ui'
import React, { useEffect, useState } from 'react'

interface RatingsProps extends StackProps {
  ratingPercentages: { [key: string]: number }
  selectedRatings?: number[]
  setSelected?: React.Dispatch<React.SetStateAction<number[]>>
}

export const Ratings: React.FC<RatingsProps> = ({
  ratingPercentages,
  selectedRatings,
  setSelected,
  ...rest
}) => {
  const [selectedLocal, setSelectedLocal] = useState<number[]>(
    selectedRatings || []
  )

  useEffect(() => {
    setSelectedLocal(selectedRatings || [])
  }, [selectedRatings])

  const ratings = Array.from(Object.entries(ratingPercentages)).map(
    ([key, value]) => ({
      isSelected: selectedLocal.includes(Number(key)),
      percentage: value,
      rating: Number(key),
    })
  )

  const handleClick = (isSelected: boolean, rating: number) => {
    if (isSelected) {
      setSelectedLocal(selectedLocal.filter((item) => item !== rating))
      setSelected?.((current) => current.filter((item) => item !== rating))
    } else {
      setSelectedLocal([...selectedLocal, rating])
      setSelected?.((current) => [...current, rating])
    }
  }

  return (
    <VStack
      border="1px solid var(--chakra-colors-neutral-200)"
      borderRadius="0.5rem"
      color="neutral.700"
      gap="1rem"
      minHeight="15.625rem"
      mt="0 !important"
      paddingX="1rem"
      paddingY="1.5rem"
      width="100%"
      {...rest}
    >
      <Text fontSize="1.125rem" fontWeight="700">
        Notas
      </Text>
      {[...ratings.reverse()].map(({ isSelected, percentage, rating }) => {
        return (
          <HStack key={rating} mt="0 !important" width="100%">
            {!!setSelected && (
              <Checkbox
                borderColor="neutral.200"
                isChecked={isSelected}
                onChange={() => handleClick(isSelected, rating)}
              />
            )}

            <HStack
              backgroundColor="neutral.50"
              border="1px solid var(--chakra-colors-neutral-300)"
              borderRadius="0.625rem"
              paddingX="0.5rem"
              paddingY="0.25rem"
            >
              <HStack>
                <Text
                  fontSize="0.625rem"
                  fontWeight="700"
                  lineHeight="0.625rem"
                >
                  {rating}
                </Text>
                <Divider
                  backgroundColor="neutral.300"
                  minHeight="0.75rem"
                  width="0.0625rem"
                />
                <IconStarReview />
              </HStack>
            </HStack>

            <Progress
              backgroundColor="white"
              border="1px solid var(--chakra-colors-neutral-400)"
              borderRadius="full"
              colorScheme="primary"
              flex="1"
              height="0.5rem"
              value={percentage}
            />
            <Text
              color="neutral.700"
              fontSize="0.625rem"
              fontWeight="700"
              lineHeight="0.625rem"
            >
              {percentage.toString().replace(/\D/g, '')}%
            </Text>
          </HStack>
        )
      })}
    </VStack>
  )
}
